export const EXPAND_COLUMN = {};